<template>
  <div>
    <div v-if="type === '1'">
      <div class="cType1">
        <div class="cType1__left"></div>
        <div>
          <div class="cType1__label">{{ label }}</div>
          <div class="cType1__text">{{ value }}</div>
        </div>
      </div>
    </div>
    <div v-if="type === '2'">
      <div class="cType2">
        <div class="cType2__right">
          <div
            style="
              display: flex;
              align-items: baseline;
              justify-content: center;
              gap: 6px;
            "
          >
            <div class="cType2__label">{{ label }}</div>
            <div v-if="bq && tagType" :class="tagType">
              {{ bq }}
            </div>
            <!--            <el-tag :type="tagType" effect="dark">{{ bq }}</el-tag>-->
          </div>
          <div class="cType2__text">
            <img :src="cardType2" alt="" />
            {{ value }}
            <img :src="cardType2_1" alt="" />
            {{ value1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cardType2 from "@/assets/images/cardType2.png";
import cardType2_1 from "@/assets/images/edit.png";

export default {
  name: "base-cardType",
  props: {
    type: {
      type: [String, Number],
      default: 1,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    value1: {
      type: String,
      default: "",
    },
    bq: {
      type: String,
      default: "",
    },
    tagType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cardType2,
      cardType2_1,
    };
  },
};
</script>

<style lang="less" scoped>
.cType1 {
  display: flex;
  gap: 12px;
  align-items: center;

  &__left {
    width: 4px;
    height: 40px;
    background: #37ccfd;
    border-radius: 2px;
  }

  &__label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 14px;
    margin-bottom: 8px;
  }

  &__text {
    font-family: D-DIN-PRO, D-DIN-PRO;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    line-height: 18px;
  }
}

.cType2 {
  display: flex;
  align-items: center;
  justify-content: center;

  &__right {
    text-align: center;
    min-width: 490px;
    height: 67px;
    background: linear-gradient(
      270deg,
      rgba(59, 255, 246, 0) 0%,
      rgba(59, 255, 246, 0.3) 54%,
      rgba(59, 255, 246, 0) 100%
    );
    padding-left: 16px;
  }

  &__label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #ffffff;
    line-height: 33px;
    margin-bottom: 8px;
  }

  &__text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;

    img {
      height: 16px;
    }
  }
}
.success {
  height: 24px;
  background: #67c23a;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  font-size: 14px;
}
.danger {
  height: 24px;
  background: #f56c6c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  font-size: 14px;
}
</style>
